export default "__VITE_ASSET__mGEy0xMl__"